// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 此处后端没有提供注释 GET /app/permissions/getListAysnc */
export async function getListAysnc(options?: { [key: string]: any }) {
  return request<API.PermissionsDto[]>('/app/permissions/getListAysnc', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /app/permissions/getPagedListAysnc */
export async function getPagedListAysnc(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.GetPagedListAysncParams,
  options?: { [key: string]: any },
) {
  return request<API.PagedResultDto1PermissionsDto>(
    '/app/permissions/getPagedListAysnc',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 此处后端没有提供注释 GET /app/permissions/getRolePermissionsListAysnc */
export async function getRolePermissionsListAysnc(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.GetRolePermissionsListAysncParams,
  options?: { [key: string]: any },
) {
  return request<API.PermissionsDto[]>(
    '/app/permissions/getRolePermissionsListAysnc',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 此处后端没有提供注释 POST /app/permissions/savePermissions */
export async function savePermissionsAsync(
  body: API.PermissionsDto,
  options?: { [key: string]: any },
) {
  return request<API.PermissionsDto>('/app/permissions/savePermissions', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 POST /app/permissions/saveRolePermissions */
export async function saveRolePermissionsAsync(
  body: API.PermissionGrantsDto,
  options?: { [key: string]: any },
) {
  return request<API.ApiResult>('/app/permissions/saveRolePermissions', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
